import styled, { css } from 'styled-components';
import { colors } from 'global/colors';

export const TestContainer = styled.div`
  padding-top: 55px;
`;

export const TopHeadingContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 15px;
`;

export const TestName = styled.h2`
  color: ${colors.darkBlue};
`;

export const QuestionAndOptionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: ${(props) => (props.width ? `${props.width}%` : null)};

  @media (min-width: 1200px) {
    ${(props) =>
      props.setMaxHeight &&
      css`
        max-height: 440px;
        overflow: auto;
      `}
  }
`;

export const QuestionAndOptionsContainer = styled.div`
  padding: 0.5rem;
  display: flex;
  width: 100%;
  font-size: 14px;
  flex-wrap: wrap;
`;

export const TimerAndQuestionsContainer = styled.div`
  flex: 0 0 25%;
  @media (max-width: 991px) {
    flex: 0 0 100%;
  }
`;

export const QuestionComponent = styled.div`
  border: 3px solid ${colors.darkBlue};
  padding: 0.5rem;
  flex: ${(props) => (props.isAdaptiveTest ? '0 0 100%' : '0 0 75%')};

  @media (max-width: 991px) {
    flex: 0 0 100%;
  }
`;

export const QuestionsBoxContainer = styled.div`
  background: ${colors.darkBlue};
  margin-left: 10px;
  padding: 5px;

  @media (max-width: 991px) {
    margin-top: 10px;
    padding-top: 12px;
    margin-left: 0;
  }
`;

export const QuestionNumber = styled.h4`
  margin-bottom: 20px;
  margin-top: 6px;
`;

export const QuestionSection = styled.div`
  margin-bottom: 25px;
  flex: 0 0 50%;

  @media (max-width: 767px) {
    flex: 0 0 100%;
  }
`;

export const OptionsContainer = styled.div`
  vertical-align: top;
  flex: 0 0 50%;
  padding-left: 1rem;
  @media (max-width: 767px) {
    flex: 0 0 100%;
    padding: 0;
    margin-left: 0px !important;
  }
`;

export const NavigationButtonsComponent = styled.div`
  margin-top: 20px;
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const QuestionsSelectionContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 2rem);
  justify-content: center;
  align-content: center;
  gap: 0.8rem;
`;

export const QuestionsSelectionButton = styled.button`
  border: 1px solid #fff;
  background: rgba(0, 0, 0, 0.05);
  color: #fff;
  height: 2rem;
  padding: 0px;
  width: 2rem;
  :hover {
    background: ${colors.green};
    border-color: ${colors.green};
  }
  :focus {
    outline: 1px !important;
  }

  ${(props) =>
    props.isActive &&
    css`
      opacity: 1 !important;
      color: white;
      background-color: ${colors.green} !important;
    `}
  ${(props) =>
    props.isAnswered &&
    css`
      background: rgba(0, 0, 0, 0.25);
    `}
`;

export const SubmitAndInfoButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${(props) => (props.isAdaptiveTest ? `flex-end` : `space-between;`)};
  padding: 10px;
`;

export const TimerContainer = styled.div`
  margin: 0 auto;
  width: 100%;
  position: relative;
  text-align: left;
  padding: 0.5rem;
  display: inline-table;
  text-align: center;
`;

export const TimerTextLabel = styled.div`
  color: ${(props) => (props.isAdaptiveTest ? colors.black : colors.white)};
`;

export const QuestionValue = styled.div`
  display: inline-block !important;
  background: ${colors.lightBlue2};
  display: table;
  padding: 18px;
  width: 100%;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: inherit;

  img {
    max-width: 100%;
  }
`;

export const OptionBox = styled.div`
  margin: 0;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  background-color: ${(props) => (props.isSelected ? `${colors.green}` : `${colors.lightGray}`)};
  color: ${(props) => (props.isSelected ? `${colors.white}` : `${colors.black}`)};
  padding: 10px;
  margin-bottom: 25px;
  border-radius: 2px;
  cursor: pointer;
  :hover {
    opacity: 0.7;
  }
`;

export const OptionChar = styled.div`
  margin: 0px;
  p {
    margin-bottom: 0px;
    line-height: 1.8;
  }
`;

export const OptionValue = styled.div`
  outline: none;
  border: none;
  overflow-wrap: break-word;
  white-space: inherit;
  padding-left: 5px;
  p {
    margin-bottom: 0px;
    line-height: 1.8;
  }
  img {
    max-width: 100%;
  }
`;

export const SubmissionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const SubmissionText = styled.div`
  display: block;
  text-align: center;
`;

export const SubmitTestLink = styled.a`
  color: ${colors.green} !important;
  cursor: pointer;
`;

export const ParagraphComponent = styled.div`
  background: ${colors.lightBlue2};
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: justify;
  font-size: 13px;
  line-height: 1.8;
`;

export const ParagraphAndQuestionCountComponent = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ItalicText = styled.i`
  font-size: 14px;
`;
